<template>
    <div>
        <pageheading/>
        <div class="uk-padding">
            <div class="uk-container">

            </div>
        </div>
    </div>
</template>

<script>
    import Pageheading from "../components/shared/pageheading";
    export default {
        name: "FAQs",
        components: {Pageheading}
    }
</script>

<style scoped>

</style>